import React from 'react';
import { UserStateContext } from '../Context';

/**Stylized div container
 * @param {object} props Incoming JSX attributes.
 * @param {boolean} props.doingAjax A boolean value that should be linked to a state controlled by the parent feature. This boolean value will be used as a context that all components are designed to receive.
 * @param {string} [props.className] A string value of HTML classes delimited by a space character to be concatenated with the default view component classes.
 * @param {any} props.children The children of the View component should be whatever JSX objects are needed to create the desired view. It does require at least one element as a child.
 * @param {any} props.viewTitle A JSX object to be displayed as the view or a string to be displayed as plain text.
 * @param {string} props.name A string value to be used in ID creation.
 * @returns {JSX.Element} Stylized div container
 * @see {@link https://bitbucket.org/pcgeducation/shipyard/src/master/shipyard-web/src/components/shared/View.md View Documentation} for further information
 */

function View(props) {
    const [doingAjax, setDoingAjax] = React.useState(props.doingAjax);

    React.useEffect(() => {
        setDoingAjax(props.doingAjax);
    }, [props.doingAjax]);

    return (
        <div
            className={(props.className ? props.className + ' ' : '') + 'view-component'}
            id={'view-' + props.name}
        >
            {props.viewTitle && <div className="view-title">{props.viewTitle}</div>}
            <UserStateContext.Provider value={{ doingAjax }}>{props.children}</UserStateContext.Provider>
        </div>
    );
}

export default View;
